import axios from 'axios';
// import { getToken, removeToken } from './auth'; // 假设你有处理 token 的工具函数
import { Message } from 'element-ui'; // 或其他 UI 反馈组件

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.REACT_APP_BASE_API, // 从环境变量获取基础 API 地址
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // const token = getToken();
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    // }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;

    // 假设你的后端返回数据格式为 { code: 200, data: {}, message: 'success' }
    if (res.code !== 200) {
      // 处理业务逻辑错误
      Message.error({ message: res.message || 'Error' });

      // 特定状态码处理
      // if (res.code === 401 || res.code === 403) {
      //   // 未授权或 token 过期
      //   removeToken();
      //   window.location.href = '/login'; // 跳转到登录页
      // }

      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res.data; // 直接返回有用的数据部分
    }
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      // 有响应但状态码不在 2xx 范围内
      switch (error.response.status) {
        case 400:
          error.message = '请求错误(400)';
          break;
        // case 401:
        //   error.message = '未授权，请重新登录(401)';
        //   removeToken();
        //   window.location.href = '/login';
        //   break;
        case 403:
          error.message = '拒绝访问(403)';
          break;
        case 404:
          error.message = '请求出错(404)';
          break;
        case 408:
          error.message = '请求超时(408)';
          break;
        case 500:
          error.message = '服务器错误(500)';
          break;
        case 501:
          error.message = '服务未实现(501)';
          break;
        case 502:
          error.message = '网络错误(502)';
          break;
        case 503:
          error.message = '服务不可用(503)';
          break;
        case 504:
          error.message = '网络超时(504)';
          break;
        case 505:
          error.message = 'HTTP版本不受支持(505)';
          break;
        default:
          error.message = `连接出错(${error.response.status})!`;
      }
    } else {
      // 请求超时或断网
      if (error.message.includes('timeout')) {
        error.message = '请求超时，请检查网络连接';
      } else if (error.message === 'Network Error') {
        error.message = '网络错误，请检查网络连接';
      }
    }

    Message.error({ message: error.message });
    return Promise.reject(error);
  }
);

// 封装常用方法
const http = {
  get(url, params, config = {}) {
    return service.get(url, { params, ...config });
  },

  post(url, data, config = {}) {
    return service.post(url, data, config);
  },

  // put(url, data, config = {}) {
  //   return service.put(url, data, config);
  // },

  // delete(url, params, config = {}) {
  //   return service.delete(url, { params, ...config });
  // },

  // upload(url, file, config = {}) {
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   return service.post(url, formData, {
  //     ...config,
  //     isUpload: true,
  //   });
  // },
};

export default http;
